<h2 mat-dialog-title>{{ 'FRONTEND.SALES_UI.COMMON.SELECT_ACCOUNT' | translate }}</h2>
<mat-dialog-content>
  <sales-ui-account-selector
    #accountSelector
    (selectedAccountGroupId)="setAccountGroupId($event)"
  ></sales-ui-account-selector>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button color="primary" mat-button mat-dialog-close>
    {{ 'FRONTEND.SALES_UI.COMMON.ACTION_LABELS.CANCEL' | translate }}
  </button>
  <button (click)="save()" color="primary" mat-raised-button>
    {{ 'FRONTEND.SALES_UI.COMMON.ACTION_LABELS.SAVE' | translate }}
  </button>
</mat-dialog-actions>
